import {
  PermissionRequestAccess,
  PermissionsPersonalizedValue,
  PermissionsTypes,
  PermissionsValue,
} from './Model/callPermissions/callPermissionsModel.types';

export const MAX_COUNT_BROADCASTERS = 50;

export const MAX_COUNT_PARTICIPANTS = 200;

export const DEFAULT_ENCODER_CONFIG = {
  width: 848,
  height: 480,
  frameRate: 30,
  bitrate: 930,
};

export enum CallEventTypes {
  IncomingCall = 'INCOMING_CALL',
  Started = 'STARTED',
  Joined = 'JOINED',
  Declined = 'DECLINED',
  Finished = 'FINISHED',
  FinishAll = 'FINISH_ALL',
  Left = 'LEFT',
  ForceMute = 'FORCE_MUTE',
  Added = 'ADDED',
  Removed = 'REMOVED',
  RaiseHand = 'RAISE_HAND',
  PutHand = 'PUT_HAND',
  ForceFinish = 'FORCE_FINISH',
  PermissionsGlobalChanged = 'PERMISSIONS_GLOBAL_CHANGED',
  PermissionsGlobalMemberChanged = 'PERMISSIONS_GLOBAL_MEMBER_CHANGED',
  PermissionsMemberChanged = 'PERMISSIONS_MEMBER_CHANGED',
  PermissionRequestSent = 'PERMISSION_REQUEST_SENT',
  PermissionRequestAlreadySent = 'PERMISSION_REQUEST_ALREADY_SENT',
  PermissionsRequestCreated = 'PERMISSIONS_REQUEST_CREATED',
  PermissionsRequestDeclined = 'PERMISSIONS_REQUEST_DECLINED',
}

export enum ClientRole {
  Host = 'host',
  Audience = 'audience',
}

export const PERMISSIONS_TYPES_TRANSLATIONS = {
  [PermissionsTypes.ShareScreen]: 'call_permissions_share_screen',
  [PermissionsTypes.SwitchOnCamera]: 'call_switch_on_camera',
  [PermissionsTypes.SwitchOnMic]: 'call_switch_on_mic',
};

export const PERMISSIONS_DEFAULT_TRANSLATIONS = {
  [PermissionsValue.Everyone]: 'call_permissions_everyone',
  [PermissionsValue.AfterApprove]: 'call_permissions_everyone_afterapproval',
  [PermissionsValue.AdminsAndOwner]: 'call_permissions_admins',
};

export const PERMISSIONS_CUSTOM_TRANSLATIONS = {
  [PermissionsPersonalizedValue.Always]: 'call_permissions_always',
  [PermissionsPersonalizedValue.Never]: 'call_permissions_never',
  [PermissionsPersonalizedValue.AfterApprove]: 'call_permissions_after_approval',
};

export const PERMISSIONS_REQUEST_TYPES = {
  [PermissionsTypes.SwitchOnCamera]: PermissionRequestAccess.Camera,
  [PermissionsTypes.SwitchOnMic]: PermissionRequestAccess.Mic,
  [PermissionsTypes.ShareScreen]: PermissionRequestAccess.ScreenSharing,
};

export enum CallBlurType {
  None = 'none',
  Small = 'small',
  Large = 'large',
}

export const BlurOptions = {
  [CallBlurType.Small]: { type: 'blur', blurDegree: 1 },
  [CallBlurType.Large]: { type: 'blur', blurDegree: 3 },
};
